import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { ChatIcon } from '../content/chat-icon';
import { HeartFilledIcon } from '../internet/heart-filled-icon';
const Root = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: ${(props) => props.theme.color.black4};
  background-image: ${(props) => props.type === 'like'
    ? 'linear-gradient(180deg,rgba(255, 31, 31, 0.2) 0%, rgba(255, 31, 31, 0) 100%)'
    : 'linear-gradient(180deg, rgba(4, 217, 0, 0.20) 0%, rgba(4, 217, 0, 0.00) 100%)'};
  border-radius: 50%;
`;
const LikeIcon = styled(HeartFilledIcon) `
  color: ${(props) => props.theme.color.accent5[100]};
  width: 16px;
  height: 16px;
`;
const CommentIcon = styled(ChatIcon) `
  color: ${(props) => props.theme.color.accent6[100]};
  width: 16px;
  height: 16px;
`;
export const ProfileStatIcon = ({ type, ref, ...props }) => (_jsx(Root, { type: type, ref: ref, ...props, children: type === 'like' ? _jsx(LikeIcon, {}) : _jsx(CommentIcon, {}) }));
//# sourceMappingURL=profile-stat-icon.js.map